import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo200.png";

interface Props {
  title: string;
  subtitle?: string;
  homeLink?: boolean;
}

export default function AuthLayout(props: PropsWithChildren<Props>) {
  const { children, title, subtitle, homeLink = false } = props;

  return (
    <div className="grid min-h-screen bg-surface lg:grid-cols-2">
      <aside className="relative hidden overflow-hidden bg-primary p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <div
          className="pointer-events-none absolute inset-0 opacity-20"
          aria-hidden="true"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, #ffffff 0 2px, transparent 2.5px), radial-gradient(circle at 80% 70%, #ffffff 0 1.5px, transparent 2px)",
            backgroundSize: "72px 72px, 48px 48px",
          }}
        />
        <div
          className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full border-[28px] border-white/10"
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-[2rem] border-[20px] border-white/10"
          aria-hidden="true"
        />

        <div className="relative">
          <img
            src={Logo}
            alt=""
            width={72}
            height={72}
            className="h-[72px] w-[72px] rounded-2xl bg-white object-contain p-2"
          />
          <p className="mt-8 text-pretty text-4xl font-extrabold tracking-tight">
            QualificaURB
          </p>
          <p className="mt-3 max-w-md text-lg leading-relaxed text-white/90">
            Ferramenta analítica classificatória da qualidade socioambiental das
            praças públicas.
          </p>
        </div>

        <p className="relative text-sm text-white/75">
          UVV + UFES · Grupo CNPq Paisagem Urbana e Inclusão
        </p>
      </aside>

      <main className="flex items-center justify-center px-4 py-10 sm:px-8">
        <div className="w-full max-w-[440px]">
          <div className="mb-8 flex flex-col items-center text-center lg:hidden">
            <img
              src={Logo}
              alt="QualificaURB"
              width={88}
              height={88}
              className="h-[88px] w-[88px] object-contain"
            />
          </div>

          <div className="rounded-2xl border border-border bg-white p-6 shadow-card sm:p-8">
            <h1 className="text-2xl font-extrabold tracking-tight text-gray">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 text-sm leading-relaxed text-muted">
                {subtitle}
              </p>
            )}
            <div className="mt-6">{children}</div>
          </div>

          {homeLink && (
            <p className="mt-6 text-center text-sm text-muted">
              <Link className="font-semibold text-primary hover:underline" to="/">
                Voltar ao início
              </Link>
            </p>
          )}
        </div>
      </main>
    </div>
  );
}
